export default __webpack_public_path__ + "static/media/c5.60057e8c.png";